(function () {
    const binderView = {
        $sortable: $('#sortable'),
        $binderIssuesHeader: $('.binder__issues__header'),
        successHtml: `<p class="alert-msg alert-msg--success"><i class="icon-checkmark"></i>{message}</p>`,
        warningHtml: `<p class="alert-msg alert-msg--warning"><i class="icon-warning-triangle"></i>{message}</p>`,

        init() {
            if (this.$sortable.length) {
                this._sort.init();
            }
            this.control();
            this.additionalControl();
        },

        control() {
            // change the description state when adding new description for binder item
            $(document).on('edit:added', function (e, toggle, isDefault) {
                if (isDefault) {
                    let $accordionToggle = $(
                            '[data-content-target=#' + $(toggle).closest('.accordion__content').attr('id') + ']'
                        ),
                        labelDesc = $accordionToggle.data('description-label');

                    $accordionToggle.find('.binder__btn-icon').remove();
                    $accordionToggle.append(
                        `<i aria-hidden="true" class="icon-description"></i><span>${labelDesc}</span><i aria-hidden="true" class="icon-section_arrow_d"></i>`
                    );
                }
            });

            $(document).on('accordion:expandedSingle', function (e, toggle, target) {
                let $toggle = $(toggle),
                    $target = $(target);
                if ($target.find('.editable__wrapper').length) {
                    let $editableWrapper = $target.find('.editable__wrapper');
                    if ($toggle.is('.js--open') && $editableWrapper.is('.editable--default')) {
                        $editableWrapper.addClass('js--edit');
                    } else {
                        $editableWrapper.removeClass('js--edit');
                    }
                }
            });
            $(document).on('edit:reset', function (e, toggle, isDefault) {
                if (isDefault) {
                    let $accordionToggle = $(
                        '[data-content-target=#' + $(toggle).closest('.accordion__content').attr('id') + ']'
                    );
                    $accordionToggle.click();
                }
            });
        },
        additionalControl() {},
        _sort: {
            init() {
                let sortOptions = {
                    cursor: 'move',
                    handle: '.sortable__toggle',
                };
                if (binderView.$sortable.is('.disable-sort')) {
                    sortOptions.disabled = true;
                }
                binderView.$sortable.sortable(sortOptions);
                binderView.$sortable.on('sortstart', (event, ui) => {
                    $(ui.item).find('.sortable__toggle i').toggleClass('icon-moving icon-movable');
                });

                binderView.$sortable.on('sortstop', (event, ui) => {
                    $(ui.item).find('.sortable__toggle i').toggleClass('icon-moving icon-movable');
                    binderView._sort.edit();
                });
            },

            edit() {
                let code = binderView.$sortable.closest('.binder__issues').attr('data-binder-code'),
                    dois = '',
                    $pageNumber = binderView.$sortable.closest('.binder__issues').find('.pageNumber'),
                    $pageSize = binderView.$sortable.closest('.binder__issues').find('.pageSize');

                binderView.$sortable.children('li').each(function (index) {
                    dois += '&item' + index + '=' + $(this).attr('data-doi');
                });

                let link = '/action/reorderBinderItems?binderCode=' + code + dois; // real link
                // let link = '/specs/ux3/widgets/binder-view/templates/demo/order.json?binderCode=' + code + dois; // test link

                if ($pageNumber.length) {
                    link += '&pageNumber=' + $pageNumber.val();
                }
                if ($pageSize.length) {
                    link += '&pageSize=' + $pageSize.val();
                }

                $.ajax({
                    url: link,
                    type: 'GET',
                    success: function (data) {
                        if (data.message) {
                            binderView.$binderIssuesHeader.prepend(
                                binderView.successHtml.replace(/{message}/g, data.message)
                            );
                        }

                        let href = window.location.href,
                            newParamVal = 'customOrder';
                        if (!UX.pageBody.urlParam.test(href, 'sortBy', newParamVal)) {
                            window.location.href = UX.pageBody.urlParam.replace(href, 'sortBy', newParamVal);
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.message) {
                            binderView.$binderIssuesHeader.prepend(
                                binderView.warningHtml.replace(/{message}/g, data.responseJSON.message)
                            );
                        }
                    },
                });

                setTimeout(function () {
                    binderView.$binderIssuesHeader.find('.alert-msg--success, .alert-msg--warning').remove();
                }, 3000);
            },
        },
    };

    UX.binderView = binderView; // add to global namespace
    $(document).ready(function () {
        if ($('.binder__issues').length) {
            UX.binderView.init();
        }
    });
})();
